export const SET_ACTIVE_TAB_ITEM = 'SET_ACTIVE_TAB_ITEM';
export const GET_RESORT_DETAIL_SUCCESS = 'GET_RESORT_DETAIL_SUCCESS';
export const DEFAULT = 'DEFAULT';
export const SET_RESORT_TAB_ITEM = 'SET_RESORT_TAB_ITEM';
export const GET_ROOM_DETAIL_SUCCESS = 'GET_ROOM_DETAIL_SUCCESS';
export const GET_DURATION = 'GET_DURATION_SUCCESS';
export const GET_UNIT_CONFIG = 'GET_UNIT_CONFIG';
export const FETCH_REVIEW_LANG_LIST_SUCCESS = 'FETCH_REVIEW_LANG_LIST_SUCCESS';
export const SET_TOP_AMENITIES = 'SET_TOP_AMENITIES';
export const FETCH_TRIP_ADVISOR_REVIEW_SUCCESS = 'FETCH_TRIP_ADVISOR_REVIEW_SUCCESS';
export const FETCH_TRIP_ADVISOR_REVIEW_SUMMARY_SUCCESS = 'FETCH_TRIP_ADVISOR_REVIEW_SUMMARY_SUCCESS';
export const RESET_AU = 'RESET_AU';
export const SET_DURATION = 'SET_DURATION';
export const GET_GUEST_DETAIL_SUCCESS = 'GET_GUEST_DETAIL_SUCCESS';
export const GET_UNIT_DETAILS = 'GET_UNIT_DETAILS';
export const GET_AVAILABLE_DETAILS = 'GET_AVAILABLE_DETAILS';
export const GET_GUEST_DETAIL_APPLY = 'GET_GUEST_DETAIL_APPLY';
export const PRICED_DETAILS_INVOKE_SUCCESS = 'PRICED_DETAILS_INVOKE_SUCCESS';
export const GET_INCLUSIVE_INFO_DETAIL = 'GET_INCLUSIVE_INFO_DETAIL';
export const CALCULATE_FEE = 'CALCULATE_FEE';
export const GET_UNIT_BEFORE_PRICE = 'GET_UNIT_BEFORE_PRICE';
export const GET_CALANDER_SELECTED_DATE = 'GET_CALANDER_SELECTED_DATE';
export const RESET_AU_CALENDER = 'RESET_AU_CALENDER';
export const UPDATE_VISIBLE_UNIT_DETAILS = 'UPDATE_VISIBLE_UNIT_DETAILS';
export const UPDATE_NON_VISIBLE_UNIT_DETAILS = 'UPDATE_NON_VISIBLE_UNIT_DETAILS';
export const RESET_AU_DURATION_CHANGE = 'RESET_AU_DURATION_CHANGE';
export const SET_SEARCH_CRITERIA = 'SET_SEARCH_CRITERIA';
export const UPDATE_VISIBLE_UNIT_DETAILS_AFTER_CALCULATE_PRICE = 'UPDATE_VISIBLE_UNIT_DETAILS_AFTER_CALCULATE_PRICE';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const IS_PRICE_SUCCESS = 'IS_PRICE_SUCCESS';
export const GET_PRICE_FETCH_ERROR = 'GET_PRICE_FETCH_ERROR';
export const GET_UNIT_DETAILS_ERROR = 'GET_UNIT_DETAILS_ERROR';
export const GET_UNIT_TYPE_ERROR = 'GET_UNIT_TYPE_ERROR';
export const GET_ROOM_DETIALS_ERROR = 'GET_ROOM_DETIALS_ERROR';
export const RESORT_DETAILS_ERROR = 'RESORT_DETAILS_ERROR';
export const GET_INCLUSIVE_INFO_ERROR = 'GET_INCLUSIVE_INFO_ERROR';
export const TRIP_ADVISOR_ERROR = 'TRIP_ADVISOR_ERROR';
export const DURATION_ERROR = 'DURATION_ERROR';
export const ALL_INCLUSIVE_INFO = 'ALL_INCLUSIVE_INFO';
export const ALL_INCLUSIVE_INFO_ERROR = 'ALL_INCLUSIVE_INFO_ERROR';
export const GET_RESORT_DETAILS_ERROR = 'GET_RESORT_DETAILS_ERROR';
export const RESET_AU_FOR_TYPE_HEAD = 'RESET_AU_FOR_TYPE_HEAD';
export const UNIT_DETAILS_INVOKE_SUCCESS = 'UNIT_DETAILS_INVOKE_SUCCESS';
export const AU_HOLD_INVENTORY_STATUS = 'AU_HOLD_INVENTORY_SERVICE';
export const UPDATE_SEARCH_CRITERIA_IN_AU = 'UPDATE_SEARCH_CRITERIA_IN_AU';
export const RESET_UNIT_TAB = 'RESET_UNIT_TAB';
export const GET_AGGREGATED_AU_SUCCESS = 'GET_AGGREGATED_AU_SUCCESS';
export const GET_AGGREGATED_AU_FAILURE = 'GET_AGGREGATED_AU_FAILURE';
export const SET_BOOKABLE_VISIBLE_UNITS = 'SET_BOOKABLE_VISIBLE_UNITS';
export const UPDATE_NONBOOKABLE_UNITS = 'UPDATE_NONBOOKABLE_UNITS';
export const UPDATE_BOOKABLE_UNITS = 'UPDATE_BOOKABLE_UNITS';
export const SET_IS_PRICE_SUCCESS = 'SET_IS_PRICE_SUCCESS';

